import request from '@/utils/request'

export const action = process.env.VUE_APP_BASE_API + '/api/file/uploadOssa'

// 查询参数配置列表
export function configList(query) {
  return request({
    url: '/biz/paramConfig/list',
    method: 'get',
    params: query
  })
}

// 修改参数设置
export function editConfig(data) {
  return request({
    url: '/biz/paramConfig',
    method: 'put',
    data: data
  })
}

// 删除参数设置
export function delConfig(paramIds) {
  return request({
    url: `/biz/paramConfig/${paramIds}`,
    method: 'delete'
  })
}

// 参数设置启用
export function switchConfig(data) {
  return request({
    url: `/biz/paramConfig/updateIsEnable`,
    method: 'put',
    params: data
  })
}

// 查询广告列表
export function bannerList(query) {
  return request({
    url: '/biz/banner/list',
    method: 'get',
    params: query
  })
}
// 新增banner
export function addBanner(data) {
  return request({
    url: '/biz/banner',
    method: 'post',
    data: data
  })
}
// 编辑广告
export function editBanner(data) {
  return request({
    url: '/biz/banner',
    method: 'put',
    data: data
  })
}
// banner启用
export function switchBanner(data) {
  return request({
    url: `/biz/banner/updateIsEnable`,
    method: 'put',
    params: data
  })
}
// 删除参数设置
export function delBanner(ids) {
  return request({
    url: `/biz/banner/${ids}`,
    method: 'delete'
  })
}
// 删除参数设置
export function getStatistics() {
  return request({
    url: `/biz/data/getStatistics`,
    method: 'get'
  })
}

// 区域列表
export function regionList(query) {
  return request({
    url: `/biz/region/list`,
    method: 'get',
    params: query
  })
}


// 省市接口
export function provincePclist() {
  return request({
    url: `/biz/areaProvince/province/pclist`,
    method: 'get',
  })
}

// 新增区域
export function postRegion(data) {
  return request({
    url: `/biz/region`,
    method: 'post',
    data: data
  })
}

// 编辑区域
export function putRegion(data) {
  return request({
    url: `/biz/region`,
    method: 'put',
    data: data
  })
}

// 删除区域
export function delRegion(id) {
  return request({
    url: `/biz/region/${id}`,
    method: 'delete',
  })
}
